import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Security, LoginCallback } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import { createStructuredSelector } from "reselect";
import { LoginHandler } from "@tailormed/common-client/component/LoginHandler";
import { ServerError } from "@tailormed/common-client/component/ServerError";
import { selectServerError } from "@tailormed/common-client/store/selector";

import { Login } from "../screen/Login";
import { Routes } from "../constant/routes";
import { SecuredRouter } from "./SecuredRouter";
import ACTIONS from "../store/action";
import { ColumnsKeys } from "../constant/columns";
import { oktaConfig } from "../constant/config";
import {
  ErrorPageLayout,
  AppLayout,
  LogoContainer,
  TailormedLogoIcon,
  TailormedVisualIcon,
  TailormedLogoContainer,
  TailormedHeaderText
} from "../component/AppLayout";
import { getAuthInstance } from "@tailormed/common-client/services/auth";
import { selectPatientTableColumns } from "../store/selector";

const history = createBrowserHistory();

const MainRouterComponent = ({ setTableColumns, hasServerError }) => {
  const [redirectedToLogin, setRedirectedToLogin] = useState(false);
  const [oktaAuth, setOktaAuth] = useState(null);

  const clientId = useSelector((state) => state.oktaClientId);
  useEffect(() => {
    if (clientId) {
      setOktaAuth(getAuthInstance(oktaConfig?.redirectUri, clientId));
    }
  }, [clientId]);

  const stateColumnNames = useSelector(selectPatientTableColumns);
  const updateColumnSelector = () => {
    const storedColumnNames = JSON.parse(localStorage.getItem(ColumnsKeys.tableColumns));
    if (storedColumnNames) {
      setTableColumns({ ...stateColumnNames, ...storedColumnNames });
    }
  };

  useEffect(() => {
    updateColumnSelector();
  }, [setTableColumns]);

  const onAuthRequired = () => {
    setRedirectedToLogin(true);
    history.push(Routes.ROOT + Routes.LOGIN);
  };

  if (hasServerError) {
    return (
      <Router history={history}>
        <ServerError
          ErrorPageLayout={ErrorPageLayout}
          AppLayout={AppLayout}
          LogoContainer={LogoContainer}
          TailormedLogoIcon={TailormedLogoIcon}
          TailormedVisualIcon={TailormedVisualIcon}
          TailormedLogoContainer={TailormedLogoContainer}
          TailormedHeaderText={TailormedHeaderText}
        />
      </Router>
    );
  }

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return oktaAuth ? (
    <Router history={history}>
      <Security oktaAuth={oktaAuth} onAuthRequired={onAuthRequired} restoreOriginalUri={restoreOriginalUri}>
        <LoginHandler />
        <Switch>
          <Route path={Routes.ROOT + Routes.LOGIN + Routes.CALLBACK} component={LoginCallback} />
          <Route path={Routes.ROOT + Routes.LOGIN}>
            <Login redirectedToLogin={redirectedToLogin} />
          </Route>
          <Route path={"/"} component={SecuredRouter} />
        </Switch>
      </Security>
    </Router>
  ) : null;
};

const mapStateToProps = createStructuredSelector({
  hasServerError: selectServerError
});

const mapDispatchToProps = (dispatch) => ({
  setTableColumns: (tableColumns) => dispatch(ACTIONS.setPatientTableColumns(tableColumns))
});

const MainRouter = connect(mapStateToProps, mapDispatchToProps)(MainRouterComponent);

export { MainRouter, history };
